import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  private readonly resetFormsSubject = new Subject<void>();
  readonly resetForms$ = this.resetFormsSubject.asObservable();
  private adCounter = 0;

  constructor() {}

  emitResetForms() {
    this.resetFormsSubject.next();
  }

  getAdCount() {
    return this.adCounter;
  }

  incrementAdCount() {
    this.adCounter++;
  }
}
